
































import { Component, Vue } from 'vue-property-decorator';

interface PageEntry {
  userAgent?: {}
  parsedAgent: {
    os?: {
      name: string
    }
    browser?: {
      name: string
    }
  },
  ipAddress : string
  createdAt? : string
  formattedCreatedAt : string
  message : string
}

// @ts-ignore
const uaParser = require('ua-parser-js');

@Component({
  metaInfo: {
    title: 'Guestbook - Read messages',
  },
})
export default class GuestbookReader extends Vue {
  pageEntries?: Array<PageEntry>|null

  loading?: boolean

  error?: string | null

  data() {
    return {
      loading: false,
      error: null,
      pageEntries: [],
    };
  }

  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  }

  fetchData(this: GuestbookReader) {
    var self = this;
    this.error = null;
    this.pageEntries = [];
    this.loading = true;
    Vue.axios.get('/api/guestbook/read').then((response: any) => {
      this.error = null;
      this.pageEntries = [];

      const srcPageEntries = response.data.pageEntries as Array<PageEntry>;
      srcPageEntries.forEach(function formatPageEntry(this: GuestbookReader, srcEntry) {
        // Formatted agent data
        let parsedAgent = {};
        try {
          parsedAgent = uaParser(srcEntry.userAgent);
        } catch (error) {
          /* eslint-disable no-console */
          console.warn('Failed parsing a user agent for a guestbook entry.', srcEntry, error);
          /* eslint-enable no-console */
        }
        // Formatted date
        let formattedCreatedAt = '';
        try {
          const dateLV = (new Date(srcEntry.createdAt || 0)).toLocaleString('lv-LV');
          formattedCreatedAt = `${dateLV} LV`;
        } catch (error) {
          /* eslint-disable no-console */
          console.warn('Failed parsing a date for a guestbook entry.', srcEntry, error);
          /* eslint-enable no-console */
        }

        const entry : PageEntry = {
          parsedAgent,
          formattedCreatedAt,
          ipAddress: srcEntry.ipAddress,
          message: srcEntry.message,
        };

        // Exclamation means "I know 'this.pageEntries' won't be null or undefined"
        self.pageEntries!.push(entry);
      });
    }).catch((e) => {
      if (e.response.status === 401) {
        self.error = 'You are not authorized to view guestbook messages.';
      } else {
        self.error = 'Failed fetching guestbook messages.';
      }
      self.pageEntries = null;
    });
  }
}
